import { render, staticRenderFns } from "./pubcaseSim.vue?vue&type=template&id=56a4a0ce&scoped=true"
import script from "./pubcaseSim.vue?vue&type=script&lang=js"
export * from "./pubcaseSim.vue?vue&type=script&lang=js"
import style0 from "./pubcaseSim.vue?vue&type=style&index=0&id=56a4a0ce&prod&lang=scss&scoped=true"
import style1 from "./pubcaseSim.vue?vue&type=style&index=1&id=56a4a0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4a0ce",
  null
  
)

export default component.exports